module.exports = __webpack_public_path__ + "img/avatar-portfolio.92e41c6f.jpg";